import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../solar-journey.module.scss";

interface Props {
	type: "congratulations" | "feedback";
}

const CheckIcon = () => (
	<svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M1.5 6.5L5.5 10.5L13.5 1.5" stroke="var(--app-base-white)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const XIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12 4L4 12" stroke="var(--app-base-white)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M4 4L12 12" stroke="var(--app-base-white)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export const AttestationSuccessPage: React.FC<Props> = ({ type }) => {
	const navigate = useNavigate();

	const isCongrats = type === "congratulations";

	return (
		<div className={styles.successContainer}>
			<div className={styles.successCard}>
				<div className={isCongrats ? styles.successIconCircle : styles.failedIconCircle}>
					{isCongrats ? <CheckIcon /> : <XIcon />}
				</div>
				<div className={styles.successTextGroup}>
					<h2 className={styles.successHeading}>
						{isCongrats ? "Congratulations" : "So sorry"}
					</h2>
					<p className={styles.successDescription}>
						{isCongrats
							? "Your solar system has been successfully installed and is now ready to power your future with clean, renewable energy. Thank you for choosing sustainability!"
							: "We apologize for any inconvenience caused, our representative would be in touch to sort the issue"}
					</p>
				</div>
			</div>

			<div className={styles.successFooter}>
				<button
					className={styles.goHomeButton}
					onClick={() => navigate("/dashboard")}
				>
					Go Home
				</button>
			</div>
		</div>
	);
};
